/* @flow */

import { createSelector } from '@reduxjs/toolkit';

/*
|------------------------------------------------------------------------------
| INPUTS
|------------------------------------------------------------------------------
*/

const _segment = (state) => state.ui.notification;

const _getNotificationQueue = (state) => _segment(state).queue;

/*
|------------------------------------------------------------------------------
| SELECTORS
|------------------------------------------------------------------------------
*/

export const getNotificationQueue: (state: Object) => any = createSelector(
  [_getNotificationQueue],
  (x: any): any => x,
);
